import React, { useEffect, useState } from 'react';
import { useWindowWidth } from '@react-hook/window-size';
import PropTypes from 'prop-types';

export default function Row({ children, gutter }) {
  // Window Width
  const retrievedWindowWidth = useWindowWidth();
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    setWindowWidth(retrievedWindowWidth);
  }, [retrievedWindowWidth]);

  const isMobile = windowWidth <= 699;

  return (
    <div
      className="a-row"
      data-testid="row"
      style={gutter && !isMobile ? { '--row-gutter': gutter } : undefined}
    >
      {children}
    </div>
  );
}

Row.defaultProps = {
  gutter: null,
};

Row.propTypes = {
  children: PropTypes.node.isRequired,
  gutter: PropTypes.string,
};
